import { BaseReactiveValue1ggyqczzm31cy as BaseReactiveValue } from '../../../../../reactive/com/lightningkite/reactive/core/abstracts.mjs';
import { PlatformStorage_instance3kj3ny10k5ycf as PlatformStorage_instance } from '../PlatformStorage.mjs';
import { get_DefaultJson7vbyrb403mrj as get_DefaultJson } from '../navigation/serialization.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Default_getInstance27jodt8hd1bac as Default_getInstance } from '../debugger.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  valueSet3cf2hvvu95f3 as valueSet,
  lens2e2i845xidu26 as lens,
  lens26es9640ifscs as lens_0,
  MutableReactiveValuettf5l2qj6mxh as MutableReactiveValue,
} from '../../../../../reactive/com/lightningkite/reactive/core/coreInterfaces.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var PersistentPropertyClass;
function PersistentProperty() {
  if (PersistentPropertyClass === VOID) {
    class $ extends BaseReactiveValue() {
      constructor(key, defaultValue, serializer) {
        return new.target.new_com_lightningkite_kiteui_reactive_PersistentProperty_dblk10_k$(key, defaultValue, serializer);
      }
      static new_com_lightningkite_kiteui_reactive_PersistentProperty_dblk10_k$(key, defaultValue, serializer) {
        var $this = this.new_com_lightningkite_reactive_core_BaseReactiveValue_bwum4c_k$(defaultValue);
        $this.key_1 = key;
        $this.serializer_1 = serializer;
        var stored = PlatformStorage_instance.get_6bo4tg_k$($this.key_1);
        if (!(stored == null))
          try {
            protoOf(BaseReactiveValue()).set_value_v1vabv_k$.call($this, get_DefaultJson().decodeFromString_jwu9sq_k$($this.serializer_1, stored));
          } catch ($p) {
            if ($p instanceof Exception()) {
              var e = $p;
              Default_getInstance().error_vwivre_k$(["Failed to deserialize PersistentProperty '" + $this.key_1 + "': " + e.message, e]);
            } else {
              throw $p;
            }
          }
        return $this;
      }
      set_value_v1vabv_k$(value) {
        PlatformStorage_instance.set_j87cuq_k$(this.key_1, get_DefaultJson().encodeToString_k0apqx_k$(this.serializer_1, value));
        super.set_value_v1vabv_k$(value);
      }
      get_value_j01efc_k$() {
        return super.get_value_j01efc_k$();
      }
      *set_revjhg_k$(value, $completion) {
        this.set_value_v1vabv_k$(value);
        return Unit_instance;
      }
    }
    protoOf($).valueSet_aujvv6_k$ = valueSet;
    protoOf($).lens_drj4fu_k$ = lens;
    protoOf($).lens_u4wb4z_k$ = lens_0;
    initMetadataForClass($, 'PersistentProperty', VOID, VOID, [MutableReactiveValue()], [1]);
    PersistentPropertyClass = $;
  }
  return PersistentPropertyClass;
}
//region block: exports
export {
  PersistentProperty as PersistentProperty2s7ex88zm8bn9,
};
//endregion

//# sourceMappingURL=PersistentProperty.mjs.map
